import { cn } from '@/lib/utils';

type BetaTagProps = {
  className?: string;
};

export const BetaTag = ({ className }: BetaTagProps) => (
  <span
    className={cn(
      'rounded bg-surface-active px-1.5 py-1 text-[9px] font-medium uppercase leading-none tracking-wide text-foreground-muted',
      className
    )}
  >
    Beta
  </span>
);
